import { createFileRoute } from '@tanstack/react-router'
import { z } from 'zod'
import { listConnectors } from '@/api/content/connector'
import { useProjectBreadcrumb } from '@/common/useProjectBreadcrumb'
import { ConnectorPage } from '@/components/ConnectorPage'

export const Route = createFileRoute('/_auth/$orgSlug/$projectId/content/connector/')({
  validateSearch: z.object({
    connectorId: z.coerce.number().int().min(1).optional().catch(undefined)
  }),
  loader: ({ params }) => listConnectors(parseInt(params.projectId, 10)),
  head: () => ({ meta: [{ title: 'Workspace Content - Snowvault' }] }),
  component: ConnectorPageRoute
})

function ConnectorPageRoute() {
  const navigate = Route.useNavigate()
  const { projectId } = Route.useParams()
  const { connectorId } = Route.useSearch()
  const { connectors } = Route.useLoaderData()
  const { userOrgProfile } = Route.useRouteContext().user
  const { projectTitle, projectTo } = useProjectBreadcrumb()
  if (!userOrgProfile) return null
  return (
    <ConnectorPage
      breadcrumbs={[{ label: projectTitle, to: projectTo }, { label: 'Content' }, { label: 'Connectors' }]}
      connectors={connectors}
      projectId={parseInt(projectId, 10)}
      userOrgProfile={userOrgProfile}
      initialConnectorId={connectorId}
      onClearConnectorId={connectorId !== undefined ? () => void navigate({ search: {} }) : undefined}
    />
  )
}
